import { IValidationRule } from "@/types"

const depreciationPeriodValidationRules: { [s: string]: IValidationRule } = {
    assetCategoryId: {
        required: true,
    },
    periodIfrsMachines: {
        required: true,
        type: "integer",
        min: 1,
        max: 1000,
    },
    periodLocalMachines: {
        required: true,
        type: "integer",
        min: 1,
        max: 1000,
    },
    periodIfrsEquipment: {
        required: true,
        type: "integer",
        min: 1,
        max: 1000,
    },
    periodLocalEquipment: {
        required: true,
        type: "integer",
        min: 1,
        max: 1000,
    },
}

export default depreciationPeriodValidationRules
